import { render, staticRenderFns } from "./CustomerActivity.vue?vue&type=template&id=2d3b81f8&"
import script from "./CustomerActivity.vue?vue&type=script&lang=ts&"
export * from "./CustomerActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports